/** @jsxImportSource theme-ui */
import { jsx } from 'theme-ui';
import slugger from 'github-slugger';
import { Heading, Box } from '@theme-ui/components';
import { Accordion } from './';
import { typography, colors } from '../../styles/theme';

const FAQs = ({ nodes }) => {
  const richResultQuestionProps = {
    itemprop: 'name',
  };
  const richResultSectionProps = {
    itemscope: 'true',
    itemprop: 'mainEntity',
    itemtype: 'https://schema.org/Question',
  };

  return (
    <div itemscope="true" itemtype="https://schema.org/FAQPage">
      {nodes.map(({ title, faqList }, index) => {
        faqList.sort((faq1, faq2) => faq1.questionNo - faq2.questionNo);
        return (
          <Box mt={index !== 0 ? [4, 4, 5] : 0 } key={`faqsection-${index}`}>
            <Heading
              as="h2"
              id={slugger.slug(title)}
              sx={styles.heading}
            >
              {title}
            </Heading>
            <Box sx={styles.faq}>
              <Accordion
                richResultSectionProps={richResultSectionProps}
                richResultQuestionProps={richResultQuestionProps}
              >
                {faqList.map(({ question, answer }, index) => (
                  <div label={question} key={`q-${index}`} showChevronIcon>
                    <div
                      itemscope="true"
                      itemprop="acceptedAnswer"
                      itemtype="https://schema.org/Answer">
                      <Box
                        sx={styles.answer}
                        dangerouslySetInnerHTML={{ __html: answer }}
                        itemprop="text"
                      />
                    </div>
                  </div>
                ))}
              </Accordion>
            </Box>
          </Box>
        );
      })}
    </div>
  );
};

const styles = {
  heading: {
    ...typography.h2,
    mb: "1.5rem",
    textAlign: ["center", "center", "center", "left"]
  },
  faq: {
    ".accordion-label": {
      ...typography.textLg500,
    },
    ".accordion-section": {
      padding: "1.5rem",
      border: `1px solid ${colors.primary200}`,
      borderRadius: "1rem",
      marginBottom: 0,
    },
    ".accordion-container": {
      display: "flex",
      flexDirection: "column",
      gap: 3
    },
    ".accordion-heading": {
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
    },
  },
  answer: {
    mt: 3, ...typography.textMd400,
    a: {
      color: colors.primaryMain,
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline"
      }
    }
  }
};

export default FAQs;
